import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

// Services
import { CustomPageService } from '../../../services/custom-page.service';

@Component({
  selector: 'app-local-resources',
  templateUrl: './local-resources.component.html',
  styleUrls: ['./local-resources.component.scss']
})
export class LocalResourcesComponent implements OnInit {

  constructor(private customPage: CustomPageService,
    private storage: LocalStorageService,
    private router: Router
  ) { }

  res: any;
  isLoadingLocalResources: boolean = null;
  moduleName = 'localResources';

  ngOnInit() {
    this.getLocalResources();
  }

  getLocalResources() {
    this.isLoadingLocalResources = true;
    this.storage.retrieve(this.moduleName);
    const localResources = this.customPage.getLocalResources();
    localResources.
      then(() => {
        this.storage.store(this.moduleName, localResources);
        this.res = localResources;
        this.isLoadingLocalResources = false;
      },
      err => {
        this.router.navigate(['/error']);
        throw err;
      }
    );
  }


}
